import { render, staticRenderFns } from "./ModalAddSecretary.vue?vue&type=template&id=8766c5de&"
import script from "./ModalAddSecretary.vue?vue&type=script&lang=js&"
export * from "./ModalAddSecretary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports